// @ts-nocheck
import { useEffect } from 'react';
import { imageCache } from '../utils/imageCache';

/**
 * Hook to preload asset images for better caching
 */
export const useImagePreloader = (assets: any[] = []) => {
  useEffect(() => {
    if (!assets || assets.length === 0) return;

    // Extract image URLs from assets
    const imageUrls = assets
      .map(asset => asset?.imageUrl)
      .filter(Boolean); // Remove null/undefined values

    if (imageUrls.length === 0) return;

    // Preload images in the background
    const preloadImages = async () => {
      console.log(`useImagePreloader: Preloading ${imageUrls.length} asset images`);
      await imageCache.preloadImages(imageUrls);
    };

    // Use a small delay to avoid blocking the main thread
    const timeoutId = setTimeout(preloadImages, 100);

    return () => clearTimeout(timeoutId);
  }, [assets]);
};

/**
 * Hook to preload asset group images for better caching
 */
export const useGroupImagePreloader = (groups: any = {}) => {
  useEffect(() => {
    if (!groups || Object.keys(groups).length === 0) return;

    // Extract image URLs from groups
    const imageUrls = Object.values(groups)
      .map((group: any) => group?.profilePictureUrl)
      .filter(Boolean); // Remove null/undefined values

    if (imageUrls.length === 0) return;

    // Preload images in the background
    const preloadImages = async () => {
      console.log(`useGroupImagePreloader: Preloading ${imageUrls.length} group images`);
      await imageCache.preloadImages(imageUrls);
    };

    // Use a small delay to avoid blocking the main thread
    const timeoutId = setTimeout(preloadImages, 100);

    return () => clearTimeout(timeoutId);
  }, [groups]);
};

export default useImagePreloader;